import { useSubscription } from '@apollo/client';
import { captureException } from '@sentry/react';
import { ORDER_CHANGE_SUBSCRIPTION, ORDER_CHANGE_SUBSCRIPTION_OPTIONS } from '@/graphql/queries/orders';
import { shouldGuardSave } from '../utils/staleSave';

/**
 * Live `{ order_id, last_modified_at, order_status, ... }` row for the order the modal is
 * editing, or null until the feed delivers. Subscribes only while the modal is open on a saved
 * order and not in read-only mode, where Done is disabled and there is nothing to protect. A feed error is reported and otherwise ignored: the
 * Done guard still protects the save.
 *
 * @param {{ open: boolean, isNewOrder: boolean, readOnly?: boolean, order?: { order_id?: string } }} args
 * @returns {object|null}
 */
export const useOrderChangeFeed = ({ open, isNewOrder, readOnly = false, order }) => {
    const { data } = useSubscription(ORDER_CHANGE_SUBSCRIPTION, {
        ...ORDER_CHANGE_SUBSCRIPTION_OPTIONS,
        skip: !open || readOnly || !shouldGuardSave({ isNewOrder, order }),
        variables: { order_id: order?.order_id },
        onError: (err) => {
            console.error(err);
            captureException(err);
        },
    });
    return data?.order || null;
};
